import QueryString from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { toast } from 'react-toastify';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';

const BatchWiseInventory = () => {
    const { billString } = useParams();
    const { billNo, master_grey_vendor_id, quality, location } = JSON.parse(
        atob(billString)
    );
    const [loading, setLoading] = useState(false);
    const [inventoryData, setInventoryData] = useState([]);

    useEffect(() => {
        const fetchInventory = async () => {
            try {
                setLoading(true);
                const string = QueryString.stringify({
                    billNo,
                    master_grey_vendor_id,
                    location,
                    quality,
                });

                const resp = await authAxiosInstance.get(
                    `/inventory/byBatchNo?${string}`
                );
                setInventoryData(resp.data.data.docs);
            } catch (error) {
                console.log(error);
                toast.error('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };
        fetchInventory();
    }, [billString]);

    const cols = useMemo(() => {
        return [
            {
                Header: 'batchNo#',
                accessor: '_id.batchNo',
                Cell: ({ row }) => {
                    const string = btoa(
                        JSON.stringify({
                            location,
                            billNo: row.original.billNo,
                            batchNo: row.original._id?.batchNo,
                            master_grey_vendor_id,
                        })
                    );
                    return (
                        <Link
                            to={`/dashboard/bill-inventory/${string}`}
                            className="text-indigo-600 underline"
                        >
                            {row.original._id.batchNo}
                        </Link>
                    );
                },
            },
            {
                Header: 'location',
                accessor: 'location.name',
            },
            {
                Header: 'Quality',
                accessor: 'quality.name',
            },
            {
                Header: 'greyReceived',
                Cell: ({ row }) => {
                    return (
                        <div>{row.original['stagesMap']['greyReceived']}</div>
                    );
                },
            },

            {
                Header: 'Master Vendor Name',
                accessor: 'master_grey_vendor_name',
            },
        ];
    }, [billString]);
    return (
        <PageWithCard
            heading={`${loading ? 'Loading...' : inventoryData?.[0]?.vendorName}`}
        >
            <TableWithHeadingAndSearch
                heading={'Inventory'}
                columns={cols}
                data={inventoryData}
            />
        </PageWithCard>
    );
};

export default BatchWiseInventory;
